import Tags from "./Tags";
import { getFieldValue } from "@digitallab/grid-common-frontend-components";

const ChipRender = (params) => {
  const value = getFieldValue(params?.data, "tags", []);
  let chips = [];

  if (Array.isArray(value)) {
    chips = value;
  } else if (typeof value === "string") {
    // Handle comma-separated string or single value
    chips = value.includes(",") ? value.split(",").map(t => t.trim()).filter(Boolean) : [value];
  } else if (value) {
    chips = [String(value)];
  } else {
    chips = [];
  }

  return <Tags chips={chips} />;
};

export default ChipRender;
